import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 「2 車両の配送計画を入れ替える」の対象 deliveryId を解決する。
 *
 * V3Plans の swapRequest は delivery（= 勤務）2 件を受け取る
 * (V3Plans/Component.tsx:1133)。同じ勤務の中の回転同士は同じ delivery を指すため
 * 入れ替えても意味が無い（サンプル MapPage.tsx:1376-1384 も同じ条件でボタンを出し分ける）。
 *
 * Why not 車両で弾く: 1 台に 2 人が同じ時間帯で乗る勤務では、別々の勤務なのに
 * 入れ替えられなくなる。API も車両が同じかは見ていない。
 *
 * 条件を満たさなければ null。呼び出し側はボタンごと出さない
 * （押せるのに必ず失敗する選択肢を作らない = buildMoveTargets と同じ方針）。
 */
export function resolveSwapTargets(
  selectedRowIds: ReadonlySet<string>,
  rowGroups: readonly VehicleRowGroup[],
): [number, number] | null {
  const selected = rowGroups
    .flatMap((g) => g.rows)
    .filter((row) => selectedRowIds.has(row.rowId));

  // 行が 2 つ揃わない（1 台・3 台以上・存在しない rowId）
  if (selected.length !== 2) return null;
  // placeholder 行は実在の勤務を持たないので API へ渡しても弾かれる
  if (selected.some((row) => row.source.isPlaceholderRow)) return null;
  // 同じ勤務の中の 2 回転
  if (selected[0].source.deliveryId === selected[1].source.deliveryId) return null;

  return [selected[0].source.deliveryId, selected[1].source.deliveryId];
}
